import { errorPlayerNotCreated } from './utils';
export const playerDestroy = async (player) => {
    if (!player) {
        throw errorPlayerNotCreated;
    }
    await player?.destroy();
};
